module.exports = __webpack_public_path__ + "img/search.5e4ac72a.svg";